import { cn } from "@/lib/utils";

export function Kicker({
	children,
	className,
}: {
	children: React.ReactNode;
	className?: string;
}) {
	return (
		<span
			className={cn(
				"inline-block font-display text-sm tracking-wide text-terracotta",
				className
			)}
		>
			{children}
		</span>
	);
}
